// Presentational helpers for the driver's "Collections" tab
// (docs/driver-collections-ui-plan.md). Row/event shapes live in
// src/types/collection.ts and are fetched through src/api/endpoints/collections.ts
// — this module holds only formatting, not data.

/**
 * `collectBy`/`isDelayed` and every other business-day boundary are computed
 * server-side (spec §5, §2.6) — this only renders the value it is given, with
 * no `Date` arithmetic of its own.
 */
export function formatDateTime(iso: string | null): string {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}
